<template>
	<router-view></router-view>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "App",
});
</script>

<style lang="scss">
@import "@/assets/scss/uViewUI_common.scss";

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	// font-family: PuHuiTi;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// text-align: center;
	color: #0f0f0f;
}

html,
body,
#app,
.el-container {
	padding: 0px;
	margin: 0px;
	height: 100%;
}
</style>
